import { render } from "./office-people-info.vue?vue&type=template&id=2f5c7dde&scoped=true&ts=true"
import script from "./office-people-info.vue?vue&type=script&lang=ts"
export * from "./office-people-info.vue?vue&type=script&lang=ts"

import "./office-people-info.vue?vue&type=style&index=0&id=2f5c7dde&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5c7dde"]])

export default __exports__